import {singleton} from "tsyringe";
import {container} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";
import {OpenNewKeywordDialogCommand} from "../open-new-keyword-dialog.command";
import {UiHelper} from "../../helpers/ui.helper";
import {Keyword} from "../../domain/entities/keyword.entity";
import {AbstractCommand} from "../abstract.command";
import {EntityManager} from "../../persistence/entity.manager";

@CommandHandler(OpenNewKeywordDialogCommand)
@singleton()
export class OpenNewKeywordDialogCommandHandler implements ICommandHandler<void> {
    
    public async handle(command: ICommand<void>): Promise<void> {
        const entityManager = container.resolve(EntityManager);
        const keywordRepository = entityManager.getRepositoryForEntity(Keyword);
        
        if (!keywordRepository) {
            throw new Error('Keyword repository not found');
        }
        
        const keyword = await keywordRepository.create();
        
        UiHelper.openDialogEntityEdit<AbstractCommand<Keyword>>(
            Keyword,
            keyword,
            {
                creationMode: true,
                closable: true
            }
        );
    }
}